import React, { Suspense } from "react";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { UserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/UserGroupMenu";
import { Section } from "../../Common/layout/Section";
import { PaymentManagement } from "./Payments";
import { Switch } from "react-router-dom";
import { Permissions } from "../../../util/Permissions";

const PaymentManagementPages = () => {
    return <>
        <AsideMenu>
            <UserGroupMenu destination="/payments" />
        </AsideMenu>
        <Section>
            <Suspense fallback={<LayoutSplashScreen />}>
                <Switch>
                    <ContentRoute path="/payments/:userGroup" permission={Permissions.PAYMENTS} component={PaymentManagement} />
                </Switch>
            </Suspense>
        </Section>
    </>
};

export default PaymentManagementPages;
